module.exports = __webpack_public_path__ + "img/flip-horizontal.9308e886.svg";